import { render } from "./MailKonfiguration.vue?vue&type=template&id=3ad7182a"
import script from "./MailKonfiguration.vue?vue&type=script&lang=js"
export * from "./MailKonfiguration.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__